webpackJsonp([9],{

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(686)
}
var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(649),
  /* template */
  __webpack_require__(834),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-20d5da74",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ls = __webpack_require__(27);
var configurations = __webpack_require__(33);
var cloudinarySettings = configurations.cloudinary_settings;
var cloud_name = configurations.cloudinary_cloudName;
var upload_preset = configurations.cloudinary_preset;

/* harmony default export */ __webpack_exports__["a"] = ({
  //
  data: function data() {
    return {
      uploadedImgUrl: ''
    };
  },

  //
  created: function created() {
    // two set interval cz -> a page can have 2 search.
    // 1
    setInterval(function () {
      if (window.thisOfVueComp.$store.state.uploadImage_2.qStr_thisTagWasSearchedLast != window.thisOfVueComp.$store.state.uploadImage_2.qStr_tags_uploadImage && window.thisOfVueComp.$store.state.uploadImage_2.qStr_searchThisTag.length != 0) {

        window.thisOfVueComp.$store.state.uploadImage_2.qStr_thisTagWasSearchedLast = window.thisOfVueComp.$store.state.uploadImage_2.qStr_tags_uploadImage;

        window.thisOfVueComp.$store.commit('getTags_setDropdownOptions_uploadImage', {
          qTag: window.thisOfVueComp.$store.state.uploadImage_2.qStr_searchThisTag,
          qStr: window.thisOfVueComp.$store.state.uploadImage_2.qStr_tags_uploadImage
        });

        console.log("[CALLING SEARCH.........]");
      } else {}
    }, 500);
    //
    // 2
    setInterval(function () {
      if (window.thisOfVueComp.$store.state.uploadImage_2.qStr_thisTagWasSearchedLast2 != window.thisOfVueComp.$store.state.uploadImage_2.qStr_tags2_uploadImage && window.thisOfVueComp.$store.state.uploadImage_2.qStr_searchThisTag.length != 0) {

        window.thisOfVueComp.$store.state.uploadImage_2.qStr_thisTagWasSearchedLast2 = window.thisOfVueComp.$store.state.uploadImage_2.qStr_tags2_uploadImage;

        window.thisOfVueComp.$store.commit('getTags_setDropdownOptions_uploadImage', {
          qTag: window.thisOfVueComp.$store.state.uploadImage_2.qStr_searchThisTag,
          qStr: window.thisOfVueComp.$store.state.uploadImage_2.qStr_tags2_uploadImage
        });

        console.log("[CALLING SEARCH.........]");
      } else {}
    }, 500);
    //
    var str = ls.get('thumbnailImgUrl');
    var id = str.split('/')[str.split('/').length - 1];
    this.uploadedImgUrl = 'https://res.cloudinary.com/' + cloud_name + '/image/upload/w_600,h_400,c_fill,' + cloudinarySettings + '/' + upload_preset + '/' + id;
    console.log("[uploadedImgUrl] => ", this.uploadedImgUrl);
    //
  }
});

/***/ }),

/***/ 649:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixin_uploadImage__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_loaders_fullscreenLoader__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_loaders_fullscreenLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_loaders_fullscreenLoader__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



//


//
var vm = void 0;
//
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      openAddTagDialog: false,
      newTag: ''
    };
  },

  //
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixin_uploadImage__["a" /* default */]],

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['sharePhoto_uploadImage_5', 'selectThisImaggaSuggestion', 'deselectThisImaggaSuggestion', 'selectThisGoogleVisionAPI_landmark', 'deselectThisGoogleVisionAPI_landmark'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['imaggaSuggestion', 'selectedKeywords_uploadImage', 'googleCloudVisionAPI_landmarkSuggestion', 'googleCloudVisionAPI_labelSuggestion', 'imageUploadingToStorage', 'selectedLocationVisible_uploadImage'])),
  created: function created() {
    window.thisOfVueComp = this;
    vm = this;
    this.$store.commit('getGoogleVisionAPISuggestionFromLocalStorage'); //contain both imagga & vision api query from ls
  },
  mounted: function mounted() {
    // this.$refs.addTag.focus()
  },

  components: {
    loader: __WEBPACK_IMPORTED_MODULE_3__components_loaders_fullscreenLoader___default.a
  },
  watch: {
    openAddTagDialog: function openAddTagDialog() {
      if (window.thisOfVueComp.openAddTagDialog) {
        vm.$refs.addTag.focus();
      } else {
        vm.$refs.addTag.blur();
      }
    }
    //
  } });

/***/ }),

/***/ 665:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(536)(true);
// imports


// module
exports.push([module.i, ".upload-screen-1-container[data-v-20d5da74]{height:100vh;width:100%}.upload-screen-1-container .hr-text[data-v-20d5da74]{line-height:1em;position:relative;outline:0;border:0;color:#000;text-align:center;height:1.5em;opacity:.5}.upload-screen-1-container .hr-text[data-v-20d5da74]:before{content:\"\";background:#818078;position:absolute;left:0;top:50%;width:100%;height:1px}.upload-screen-1-container .hr-text[data-v-20d5da74]:after{-webkit-font-feature-settings:\"liga\";position:relative;margin-left:-100%;margin-top:-6px;font-size:24px;display:inline-block;font-family:Material Icons;content:\"keyboard_backspace\";-webkit-font-feature-settings:\"liga\" 1;font-feature-settings:\"liga\" 1;padding:0 .5em;line-height:1.5em;color:#818078;background-color:#fcfcfa}.upload-screen-1-container .suggestion-btn[data-v-20d5da74]{margin:5px;padding:5px 20px;border:1px solid #d3d3d3;border-radius:10px;outline:none;font-size:.714em}.upload-screen-1-container .tags-container .tag-headline[data-v-20d5da74]{font-size:1.286em;font-weight:700}.upload-screen-1-container .important-details-container[data-v-20d5da74]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;position:relative}.upload-screen-1-container .important-details-container .back-icon[data-v-20d5da74]{position:absolute;left:0;top:58%}.upload-screen-1-container .important-details-container .important-details[data-v-20d5da74]{width:98%;text-align:right;font-size:1.286em;font-weight:700}.upload-screen-1-container .important-details-container .hr-div[data-v-20d5da74]{margin-left:20px;position:absolute;width:90%;top:58%;left:20px;background:#d3d3d3;height:1px}.upload-screen-1-container .img-and-caption-container[data-v-20d5da74]{border-bottom:1px solid #d3d3d3;margin:19px 0 9px}.upload-screen-1-container .img-and-caption-container .img-container img[data-v-20d5da74]{width:6.429em;height:4.286em;-o-object-fit:contain;object-fit:contain}.upload-screen-1-container .img-and-caption-container .caption-container[data-v-20d5da74]{padding-left:10px;text-align:left}.upload-screen-1-container .img-and-caption-container .caption-container .caption-text-area[data-v-20d5da74]{width:100%;height:100%;outline:none;resize:none}.upload-screen-1-container .img-and-caption-container .caption-container .caption-text-area[data-v-20d5da74] ::-webkit-input-placeholder{font-size:1em}.upload-screen-1-container .img-and-caption-container .caption-container .caption-text-area[data-v-20d5da74] :-ms-input-placeholder,.upload-screen-1-container .img-and-caption-container .caption-container .caption-text-area[data-v-20d5da74] ::-ms-input-placeholder{font-size:1em}.upload-screen-1-container .img-and-caption-container .caption-container .caption-text-area[data-v-20d5da74] ::placeholder{font-size:1em}", "", {"version":3,"sources":["/home/aubergine/Documents/GitHub/pwa2020/src/components/uploadImage/uploadImage_5.vue"],"names":[],"mappings":"AACA,4CACE,aAAc,AACd,UAAY,CACb,AACD,qDACI,gBAAiB,AACjB,kBAAmB,AACnB,UAAW,AACX,SAAU,AACV,WAAa,AACb,kBAAmB,AACnB,aAAc,AACd,UAAY,CACf,AACD,4DACM,WAAY,AACZ,mBAAoB,AACpB,kBAAmB,AACnB,OAAQ,AACR,QAAS,AACT,WAAY,AACZ,UAAY,CACjB,AACD,2DACM,qCAAsC,AACtC,kBAAmB,AACnB,kBAAmB,AACnB,gBAAiB,AACjB,eAAgB,AAChB,qBAAsB,AACtB,2BAA8B,AAC9B,6BAA8B,AAC9B,uCAAwC,AACxC,+BAAgC,AAChC,eAAgB,AAChB,kBAAmB,AACnB,cAAe,AACf,wBAA0B,CAC/B,AACD,4DACI,WAAgB,AAChB,iBAAkB,AAClB,yBAA4B,AAC5B,mBAAoB,AACpB,aAAc,AACd,gBAAmB,CACtB,AACD,0EACI,kBAAmB,AACnB,eAAiB,CACpB,AACD,yEACI,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,kBAAmB,AACf,yBAA0B,AAClC,iBAAmB,CACtB,AACD,oFACM,kBAAmB,AACnB,OAAQ,AACR,OAAS,CACd,AACD,4FACM,UAAW,AACX,iBAAkB,AAClB,kBAAmB,AACnB,eAAiB,CACtB,AACD,iFACM,iBAAkB,AAClB,kBAAmB,AACnB,UAAW,AACX,QAAS,AACT,UAAW,AACX,mBAAsB,AACtB,UAAY,CACjB,AACD,uEACI,gCAAmC,AACnC,iBAAqB,CACxB,AACD,0FACM,cAAe,AACf,eAAgB,AAChB,sBAAuB,AACpB,kBAAoB,CAC5B,AACD,0FACM,kBAAmB,AACnB,eAAiB,CACtB,AACD,6GACQ,WAAY,AACZ,YAAa,AACb,aAAc,AACd,WAAa,CACpB,AACD,yIACU,aAAe,CACxB,AAID,yQACU,aAAe,CACxB,AACD,2HACU,aAAe,CACxB","file":"uploadImage_5.vue","sourcesContent":["\n.upload-screen-1-container[data-v-20d5da74] {\n  height: 100vh;\n  width: 100%;\n}\n.upload-screen-1-container .hr-text[data-v-20d5da74] {\n    line-height: 1em;\n    position: relative;\n    outline: 0;\n    border: 0;\n    color: black;\n    text-align: center;\n    height: 1.5em;\n    opacity: .5;\n}\n.upload-screen-1-container .hr-text[data-v-20d5da74]:before {\n      content: '';\n      background: #818078;\n      position: absolute;\n      left: 0;\n      top: 50%;\n      width: 100%;\n      height: 1px;\n}\n.upload-screen-1-container .hr-text[data-v-20d5da74]:after {\n      -webkit-font-feature-settings: 'liga';\n      position: relative;\n      margin-left: -100%;\n      margin-top: -6px;\n      font-size: 24px;\n      display: inline-block;\n      font-family: 'Material Icons';\n      content: \"keyboard_backspace\";\n      -webkit-font-feature-settings: 'liga' 1;\n      font-feature-settings: 'liga' 1;\n      padding: 0 .5em;\n      line-height: 1.5em;\n      color: #818078;\n      background-color: #fcfcfa;\n}\n.upload-screen-1-container .suggestion-btn[data-v-20d5da74] {\n    margin: 5px 5px;\n    padding: 5px 20px;\n    border: 1px solid lightgrey;\n    border-radius: 10px;\n    outline: none;\n    font-size: 0.714em;\n}\n.upload-screen-1-container .tags-container .tag-headline[data-v-20d5da74] {\n    font-size: 1.286em;\n    font-weight: 700;\n}\n.upload-screen-1-container .important-details-container[data-v-20d5da74] {\n    width: 100%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: flex-end;\n    position: relative;\n}\n.upload-screen-1-container .important-details-container .back-icon[data-v-20d5da74] {\n      position: absolute;\n      left: 0;\n      top: 58%;\n}\n.upload-screen-1-container .important-details-container .important-details[data-v-20d5da74] {\n      width: 98%;\n      text-align: right;\n      font-size: 1.286em;\n      font-weight: 700;\n}\n.upload-screen-1-container .important-details-container .hr-div[data-v-20d5da74] {\n      margin-left: 20px;\n      position: absolute;\n      width: 90%;\n      top: 58%;\n      left: 20px;\n      background: lightgrey;\n      height: 1px;\n}\n.upload-screen-1-container .img-and-caption-container[data-v-20d5da74] {\n    border-bottom: 1px solid lightgrey;\n    margin: 19px 0 9px 0;\n}\n.upload-screen-1-container .img-and-caption-container .img-container img[data-v-20d5da74] {\n      width: 6.429em;\n      height: 4.286em;\n      -o-object-fit: contain;\n         object-fit: contain;\n}\n.upload-screen-1-container .img-and-caption-container .caption-container[data-v-20d5da74] {\n      padding-left: 10px;\n      text-align: left;\n}\n.upload-screen-1-container .img-and-caption-container .caption-container .caption-text-area[data-v-20d5da74] {\n        width: 100%;\n        height: 100%;\n        outline: none;\n        resize: none;\n}\n.upload-screen-1-container .img-and-caption-container .caption-container .caption-text-area[data-v-20d5da74] ::-webkit-input-placeholder {\n          font-size: 1em;\n}\n.upload-screen-1-container .img-and-caption-container .caption-container .caption-text-area[data-v-20d5da74] :-ms-input-placeholder {\n          font-size: 1em;\n}\n.upload-screen-1-container .img-and-caption-container .caption-container .caption-text-area[data-v-20d5da74] ::-ms-input-placeholder {\n          font-size: 1em;\n}\n.upload-screen-1-container .img-and-caption-container .caption-container .caption-text-area[data-v-20d5da74] ::placeholder {\n          font-size: 1em;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 686:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(665);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(537)("12f0d779", content, true, {});

/***/ }),

/***/ 834:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-screen-1-container"
  }, [_c('div', {
    staticClass: "white upload-screen-1-container"
  }, [_c('div', {
    staticClass: "pa-3"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('v-icon', {
    staticClass: "grey--text",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("keyboard_backspace")]), _vm._v(" "), _c('div', {
    staticClass: "grey",
    staticStyle: {
      "width": "100%",
      "height": "1px"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "img-and-caption-container",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "img-container",
    attrs: {
      "xs4": "",
      "md1": ""
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.uploadedImgUrl),
      expression: "uploadedImgUrl"
    }]
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "caption-container",
    attrs: {
      "xs8": "",
      "md11": ""
    }
  }, [_vm._v("\n        The more relevant tags you add to this photo, the more people will discover it.\n      ")])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "tags-container",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    staticClass: "tag-headline text-xs-left"
  }, [_vm._v("\n        Tags: Selected\n      ")]), _vm._v(" "), _c('v-flex', {
    staticClass: "tag-btn-container text-xs-right"
  }, [_c('v-btn', {
    staticClass: "cyan white--text",
    staticStyle: {
      "margin": "0",
      "font-size": "11px"
    },
    attrs: {
      "round": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.openAddTagDialog = true
      }
    }
  }, [_vm._v("\n          Add new\n        ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tags-chip-container text-xs-left",
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, _vm._l((_vm.$store.state.uploadImage_5.selectedKeywords_uploadImage), function(chip, chipIndex) {
    return _c('div', {
      key: chipIndex,
      staticClass: "text-xl-left",
      staticStyle: {
        "position": "relative"
      }
    }, [_c('v-icon', {
      staticStyle: {
        "position": "absolute",
        "top": "7px",
        "right": "13px",
        "font-size": "18px",
        "z-index": "3",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.$store.state.uploadImage_5.selectedKeywords_uploadImage.splice(chipIndex, 1)
        }
      }
    }, [_vm._v("\n          clear\n        ")]), _vm._v(" "), _c('v-chip', {
      staticClass: "blue black--text",
      staticStyle: {
        "padding": "0 2vh 0 0",
        "font-size": "12px"
      },
      attrs: {
        "outline": "",
        "label": "",
        "small": ""
      }
    }, [_vm._v("\n          " + _vm._s(chip) + "\n        ")])], 1)
  }), 0), _vm._v(" "), _c('v-layout', {
    staticClass: "tags-container mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    staticClass: "tag-headline text-xs-left"
  }, [_vm._v("\n        Suggested\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-left"
  }, _vm._l((_vm.imaggaSuggestion), function(tag, key) {
    return (
      _vm.$store.state.uploadImage_5.selectedKeywords_uploadImage.indexOf(tag) == -1) ? _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (key < 10),
        expression: "key < 10"
      }],
      staticClass: "suggestion-btn ",
      on: {
        "click": function($event) {
          return _vm.selectThisImaggaSuggestion({
            tag: tag
          })
        }
      }
    }, [_vm._v("\n        " + _vm._s(tag) + "\n      ")]) : _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (
          _vm.$store.state.uploadImage_5.selectedKeywords_uploadImage.indexOf(tag) == -1),
        expression: "\n        $store.state.uploadImage_5.selectedKeywords_uploadImage.indexOf(tag) == -1"
      }],
      staticClass: "suggestion-btn",
      on: {
        "click": function($event) {
          return _vm.deselectThisImaggaSuggestion({
            tag: tag
          })
        }
      }
    }, [_vm._v("\n        " + _vm._s(tag) + "\n      ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "text-xs-right"
  }, [_c('v-btn', {
    staticClass: "primary primary--text",
    attrs: {
      "disabled": _vm.$store.state.uploadImage_5.showShareButton,
      "outline": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.sharePhoto_uploadImage_5({
          url: _vm.$route.query.url,
          resourceType: _vm.$route.query.resourceType,
          publicId: _vm.$route.query.publicId,
          //
          createdAt: _vm.$route.query.createdAt,
          //
          caption: _vm.$route.query.caption,
          locationVisible: _vm.$store.state.uploadImage_2.selectedLocationVisible_uploadImage, // now shifted to this page, instead of being in query
          emotionalAppeal: JSON.parse(_vm.$route.query.emotionalAppeal),
          //
          shareSpotLocation: JSON.parse(_vm.$route.query.shareSpotLocation), //parsed
          hasGeohash: _vm.$route.query.geoLocIsAvailable,
          //
          spotType: JSON.parse(_vm.$route.query.spotType),
          anyoneCanVisitThisSpot: _vm.$route.query.anyoneCanVisitThisSpot,
          //
          keywords: _vm.$store.state.uploadImage_5.selectedKeywords_uploadImage,
          travelInfo: _vm.$route.query.pic_desc,
          _dur2: _vm.$route.query._dur2,
          _mon2: _vm.$route.query._mon2
        })
      }
    }
  }, [_vm._v("\n        share\n      ")])], 1)], 1)]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "300"
    },
    model: {
      value: (_vm.openAddTagDialog),
      callback: function($$v) {
        _vm.openAddTagDialog = $$v
      },
      expression: "openAddTagDialog"
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('h3', {
    staticClass: "text-xs-center"
  }, [_vm._v("Add new tag!")]), _vm._v(" "), _c('v-text-field', {
    ref: "addTag",
    attrs: {
      "label": "Type image tag name"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.newTag.length > 0 ? _vm.$store.state.uploadImage_5.selectedKeywords_uploadImage.push(_vm.newTag) : '';
        _vm.newTag = '';
        _vm.openAddTagDialog = false
      }
    },
    model: {
      value: (_vm.newTag),
      callback: function($$v) {
        _vm.newTag = $$v
      },
      expression: "newTag"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary primary--text",
    attrs: {
      "small": "",
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.newTag.length > 0 ? _vm.$store.state.uploadImage_5.selectedKeywords_uploadImage.push(_vm.newTag) : '';
        _vm.newTag = '';
        _vm.openAddTagDialog = false
      }
    }
  }, [_vm._v("\n          add\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "important-details-container"
  }, [_c('div', {
    staticClass: "important-details"
  }, [_vm._v("Make it popular")])])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/v/1733832636781/js/9.5b557e28921482ff6877.js